import { Box, Paper, Typography, Chip, Divider } from '@mui/material';
import React from 'react';

interface Module {
  description: string;
  uuid: string;
  name: string;
}

interface PermissionViewProps {
  values: any;
  modules: Module[];
  groupList: any[];
  profileSubgroupList: any[];
}

const permissionTypes = [
  { label: 'Visualizar', name: 'read' },
  { label: 'Listar', name: 'list' },
  { label: 'Criar', name: 'create' },
  { label: 'Editar', name: 'update' },
  { label: 'Deletar', name: 'delete' },
];

const PermissionView: React.FC<PermissionViewProps> = ({ values, modules, groupList, profileSubgroupList }) => {
  const profileName = values.name || 'Nome não informado';
  const group = groupList.find((g) => g.uuid === values.groupUuid);
  const profileGroup = group ? group.name : 'Grupo não informado';
  const subGroup = profileSubgroupList.find((g) => g.uuid === values.profileUuid);
  const profileSubgroup = subGroup ? subGroup.name : 'Subgrupo não informado';

  return (
    <Box sx={{ width: '100%', maxWidth: '1152px', mx: 'auto' }}>
      <Typography variant="h6" mb={2}>
        Visualização de Perfil
      </Typography>

      <Paper elevation={0} sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2, backgroundColor: '#fff' }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Box>
            <Typography variant="subtitle1" fontWeight="bold">
              Nome:
            </Typography>
            <Typography variant="body1">{profileName.toUpperCase()}</Typography>
          </Box>

          <Box>
            <Typography variant="subtitle1" fontWeight="bold">
              Grupo:
            </Typography>
            <Typography variant="body1">{profileGroup}</Typography>
          </Box>

          <Box>
            <Typography variant="subtitle1" fontWeight="bold">
              Subgrupo:
            </Typography>
            <Typography variant="body1">{profileSubgroup}</Typography>
          </Box>
        </Box>

        <Divider sx={{ mb: 3 }} />

        <Typography variant="h6" mb={2}>
          Configuração de Módulos e Permissões
        </Typography>

        {modules.map((module) => {
          const isActive = values.permissions?.[module.name]?.is_active;

          return (
            <Box
              key={module.uuid}
              sx={{
                p: 2,
                mb: 2,
                border: '1px solid #e0e0e0',
                borderRadius: 1,
                backgroundColor: '#f9f9f9',
                opacity: isActive ? 1 : 0.5,
              }}
            >
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <Typography variant="subtitle1" fontWeight="bold">
                  {module.description}
                </Typography>
                <Typography variant="body2" color={isActive ? 'primary.main' : 'text.secondary'}>
                  {isActive ? 'Ativo' : 'Inativo'}
                </Typography>
              </Box>

              <Box display="flex" gap={1} flexWrap="wrap">
                Permissões: 
                {permissionTypes.map((type) => {
                  const hasPermission = values.permissions?.[module.name]?.[type.name];
                  return (
                    <Box
                      key={type.name}
                      sx={{
                        px: 1.5,
                        py: 0.5,
                        borderColor: hasPermission ? '#e9f2ea' : '#fdf7f7',
                        backgroundColor: hasPermission ? '#e9f2ea' : '#fdf7f7',
                        fontSize: 11,
                        userSelect: 'none',
                      }}
                    >
                      {type.label}
                    </Box>
                  );
                })}
              </Box>
            </Box>
          );
        })}
      </Paper>
    </Box>
  );
};

export default PermissionView;
